import { render, staticRenderFns } from "./ParapharmacyTemplateSelector.vue?vue&type=template&id=65a4069a"
import script from "./ParapharmacyTemplateSelector.vue?vue&type=script&lang=js"
export * from "./ParapharmacyTemplateSelector.vue?vue&type=script&lang=js"
import style0 from "./ParapharmacyTemplateSelector.vue?vue&type=style&index=0&id=65a4069a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports